import React, { PureComponent } from "react";
import { SvgLoader, SvgProxy } from "../react-svgmt/index";

import style from "./icon.module.css";
import { changeShapesColorInNode } from "../../utils";

export class IconMask extends PureComponent {
  render() {
    const {
      path,
      iconColor,
      css = {position: "relative"},
      className = "",
      backgroundColor
    } = this.props;
    const selector = `svg>g`;
    return (
      <div className={`${className}`}>
        <div className={`${style.iconWrapper} ${style.withMask}`} style={css}>
          <SvgLoader path={path}>
            <SvgProxy
              selector={selector}
              onElementSelected={nodes => {
                if (nodes.length) {
                  //expect always to first group be the background
                  const background = nodes.shift();
                  changeShapesColorInNode(background, backgroundColor, "rect");
                  // const svgText = document.createElementNS("http://www.w3.org/2000/svg", "text");
                  // svgText.appendChild(document.createTextNode("56k"));
                  // background.appendChild(svgText);
                  // console.log(background);
                  nodes.forEach(node => {
                    node.classList.add("highlighted");
                    changeShapesColorInNode(node, this.props.iconColor);
                    node.style.clipPath = `inset(-10px ${105 -
                      this.props.value}% -10px 0)`;
                    node.style["-webkit-clip-path"] = `inset(-10px ${100 -
                      this.props.value}% -10px 0)`;
                  });
                } else {
                  console.log("invalid SVG format, expect at-least two groups");
                }
              }}
            />
          </SvgLoader>
         {this.props.children && this.props.children}
        </div>
        {this.props.label && (
          <div
            className={`uppercase ${style.iconLabel} medium`}
            style={{
              color: iconColor
            }}
          >
            {this.props.label}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/icon/with-mask.js